import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_275xefbjkx: FaireBrandEntity = {
  token: "b_275xefbjkx",
  type: "brand",
  name: "Toyarina",
  avatarUrl:
    "https://cdn.faire.com/fastly/5cdc3bb79f730f585c55fd5fda1c1b299b7bcc4a685d38f34a26c89fc4f7828a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ef21073902f0c2aba8885092c944ffaba323b1f18c9ab84cd3a082665e236853.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5cdc3bb79f730f585c55fd5fda1c1b299b7bcc4a685d38f34a26c89fc4f7828a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ef21073902f0c2aba8885092c944ffaba323b1f18c9ab84cd3a082665e236853.png",
  location: "laurinburg, NC, USA",
  minimumOrderDollars: 0,
  rating: 3.7,
  reviewCount: 74,
  isInsider: true,
  description:
    "Toy Arena was created with one clear mission — to make retail toys simple, fast-moving, and consistently profitable.\n\nWe noticed that many retailers were stuck with toys that looked exciting online but didn’t perform in-store. Trends changed quickly, margins were tight, and sourcing reliable, affordable products was a constant challenge.\n\nSo we built Toy Arena to focus only on what truly works on shelves.\n\nEvery product we offer is selected based on real retail performance — impulse appeal, strong margins, and repeat demand. From fidget toys to interactive gadgets, our collection is designed to attract attention, drive quick purchases, and keep customers coming back.\n\nWe work directly with trusted manufacturing partners to ensure consistent quality and competitive pricing, so our retail partners can stock confidently and reorder without hesitation.\n\nAt Toy Arena, we’re more than just a supplier — we’re a partner focused on helping you sell through faster, reduce dead stock, and grow your business with products customers genuinely enjoy.\n\nWhether you run a gift shop, toy store, or general retail space, Toy Arena helps turn small products into reliable revenue.",
  meta: {
    source: "api",
    importedAt: "2026-07-17T19:42:51.933Z",
    importedBy: "entity-db-cli",
  },
};
